module.exports = __webpack_public_path__ + "img/masonry-banner-4.86ff52ef.jpg";